import React from 'react'

import { P } from '../../../style/Typography.style'
import Flex from '../../layouts/Flex'

import EmptyWrapper from '../../EmptyWrapper'

const SpeedtestSection = ({ speedTestImageUrl }) => {
  return (
    <>
      {' '}
      <P textTransform="uppercase" style={{ color: '#1A196B', marginTop: '2rem', fontWeight: 500, fontSize: '.875rem' }}>
        Speed Test Screenshot
      </P>
      {speedTestImageUrl ? (
        <Flex marginTop="0.5rem" justify="center">
          <img
            src={speedTestImageUrl}
            alt="Speed Test Result"
            style={{ maxWidth: '100%', height: 'auto' }}
          />
        </Flex>
      ) : (
        <EmptyWrapper message="No Speed Test Result Yet" />
      )}
    </>
  )
}

export default SpeedtestSection
